export default [{
  path: '/room/manager',
  name: 'room-management',
  title: '房态',
  component: () => import('@/views/room/index')
}];
